import makeStyles from "@mui/styles/makeStyles";
import { TypographyProps } from "./Typography.types";

export const useStyles = makeStyles((theme) => ({
  root: {
    position: "relative",
    fontWeight: 400,
  },
  h1: {
    fontSize: 32,
    lineHeight: "36px",
  },
  h2: {
    fontSize: 24,
    lineHeight: "28px",
  },
  h3: {
    fontSize: 20,
    lineHeight: "24px",
  },
  h4: {
    fontSize: 16,
    lineHeight: "20px",
  },
  body1: {
    fontSize: 16,
    lineHeight: "20px",
  },
  body2: {
    fontSize: 14,
    lineHeight: "18px",
  },
  body3: {
    fontSize: 12,
    lineHeight: "16px",
  },
  label1: {
    fontSize: 14,
    lineHeight: "14px",
  },
  label2: {
    fontSize: 12,
    lineHeight: "12px",
  },
  label3: {
    fontSize: 10,
    lineHeight: "10px",
  },
  chartValue: {
    fontSize: 8,
    lineHeight: "8px",
  },
  alignLeft: {
    textAlign: "left",
  },
  alignCenter: {
    textAlign: "center",
  },
  alignRight: {
    textAlign: "right",
  },
  noWrap: {
    overflow: "hidden",
    textOverflow: "ellipsis",
    whiteSpace: "nowrap",
  },
  displayInitial: {
    display: "initial",
  },
  displayInline: {
    display: "inline",
  },
  displayBlock: {
    display: "block",
  },
  fontWeightRegular: {
    fontWeight: 400,
  },
  fontWeightSemiBold: {
    fontWeight: 600,
  },
  fontWeightBold: {
    fontWeight: 700,
  },
  colorRedMain: {
    color: theme.palette.red.main,
  },
  colorRedLight: {
    color: theme.palette.red.light,
  },
  colorRedDark: {
    color: theme.palette.red.dark,
  },
  colorPrimaryMain: {
    color: theme.palette.primary.main,
  },
  colorPrimaryLight: {
    color: theme.palette.primary.light,
  },
  colorPrimaryDark: {
    color: theme.palette.primary.dark,
  },
  colorGrey50: {
    color: theme.palette.grey[50],
  },
  colorGrey100: {
    color: theme.palette.grey[100],
  },
  colorGrey200: {
    color: theme.palette.grey[200],
  },
  colorGrey300: {
    color: theme.palette.grey[300],
  },
  colorGrey400: {
    color: theme.palette.grey[400],
  },
  colorGrey500: {
    color: theme.palette.grey[500],
  },
  colorGrey600: {
    color: theme.palette.grey[600],
  },
  colorGrey700: {
    color: theme.palette.grey[700],
  },
  colorGrey800: {
    color: theme.palette.grey[800],
  },
  colorGrey900: {
    color: theme.palette.grey[900],
  },
  colorWhite: {
    color: theme.palette.common.white,
  },
  colorYellowMain: {
    color: theme.palette.yellow.main,
  },
  colorYellowDark: {
    color: theme.palette.yellow.dark,
  },
  bullet: (props: TypographyProps) => ({
    "&::before": {
      content: "''",
      display: "inline-block",
      width: 12,
      height: 12,
      marginRight: 8,
      background: props.bulletColor || "currentColor",
      borderRadius: 999,
    },
  }),
  wordBreakAll: {
    wordBreak: "break-all",
  },
}));
